import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import SearchItem from 'app/shared/models/SearchItem';

// Type definitions
interface GeolocationArea {
  fullName?: string;
  resourceId?: string;
}

interface AreaInfo {
  fullName?: string;
  resourceId?: string;
}

interface RecentSearch {
  areaInfo?: AreaInfo;
  filterDescription?: string;
  url?: string;
}

interface SavedSearch {
  filterDescription?: string;
  name?: string;
  numberOfNewResults?: number;
  url?: string;
}

interface GetSuggestionsParams {
  recent?: RecentSearch;
  saved?: Array<SavedSearch>;
  geolocationArea?: GeolocationArea;
  limit?: number;
}

const searchUtils = {
  getGeoipSearchItem(geolocationArea: GeolocationArea = {}): SearchItem {
    return new SearchItem({
      description: 'Use my current location',
      name: geolocationArea.fullName,
      type: 'geoip',
      resourceId: geolocationArea.resourceId,
      url: '',
    });
  },

  getRecentSearchItem({ recent }: { recent?: RecentSearch }): SearchItem | false {
    const recentFullName = recent && recent.areaInfo ? recent.areaInfo.fullName : '';
    const recentResourceId = recent && recent.areaInfo ? recent.areaInfo.resourceId : '';
    let recentSearchItem: SearchItem | false;
    if (!isEmpty(recent)) {
      // very loose check to know if recent is set or not.
      recentSearchItem = new SearchItem({
        description: recent.filterDescription,
        name: recentFullName,
        type: 'recentSearch',
        resourceId: recentResourceId,
        url: recent.url,
      });
    } else {
      recentSearchItem = false;
    }
    return recentSearchItem;
  },

  getSavedSearchItems({ saved }: { saved?: Array<SavedSearch> }): Array<SearchItem> {
    return map(saved, (savedSearch: SavedSearch) => {
      return new SearchItem({
        description: savedSearch.filterDescription,
        name: savedSearch.name,
        numberOfNewResults: savedSearch.numberOfNewResults,
        type: 'savedSearch',
        resourceId: '',
        url: savedSearch.url,
      });
    });
  },

  getSuggestions({ recent, saved, geolocationArea, limit = 1 }: GetSuggestionsParams = {}): Array<SearchItem | false> {
    const recentSearchItem = searchUtils.getRecentSearchItem({ recent });
    const geoipSearchItem = searchUtils.getGeoipSearchItem(geolocationArea);
    const savedSearchItems = searchUtils.getSavedSearchItems({ saved });
    let suggestions: Array<SearchItem | false> = [];

    suggestions.push(geoipSearchItem);
    if (recentSearchItem) {
      suggestions.push(recentSearchItem);
    }
    suggestions = suggestions.concat(savedSearchItems);
    return suggestions.slice(0, limit);
  },
};

export default searchUtils;
